export default [
  // 自主解冻
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "unfreeze" */ '@/views/unfreeze/index'),
    meta: {
      title: '异常处理'
    }
  },
  {
    path: '/result',
    name: 'result',
    component: () => import(/* webpackChunkName: "unfreeze" */ '@/views/unfreeze/result'),
    meta: {
      title: '结果'
    }
  },
  {
    path: '/fileCheck',
    name: 'fileCheck',
    component: () => import(/* webpackChunkName: "unfreeze" */ '@/views/unfreeze/file_check'),
    meta: {
      title: '补充资料'
    }
  },
  {
    path: '/phoneCheck',
    name: 'phoneCheck',
    component: () => import(/* webpackChunkName: "unfreeze" */ '@/views/unfreeze/phone_check'),
    meta: {
      title: '手机号校验'
    }
  },
  {
    path: '/cardCheck',
    name: 'cardCheck',
    component: () => import(/* webpackChunkName: "unfreeze" */ '@/views/unfreeze/card_check'),
    meta: {
      title: '持卡人身份验证'
    }
  },
  {
    path: '/faceCheck',
    name: 'faceCheck',
    component: () => import(/* webpackChunkName: "unfreeze" */ '@/views/unfreeze/face_check'),
    meta: {
      title: '人脸认证'
    }
  },
  {
    path: '/faceResult',
    name: 'faceResult',
    component: () => import(/* webpackChunkName: "unfreeze" */ '@/views/unfreeze/face_result'),
    meta: {
      title: '人脸认证'
    }
  },
  // KYC
  {
    path: '/kycAuth/index',
    name: 'kyc_index',
    component: () => import(/* webpackChunkName: "kyc" */ '@/views/kyc_auth/index'),
    meta: {
      title: '人脸核验'
    }
  },
  {
    path: '/kycAuth/cert_face',
    name: 'kyc_cert_face',
    component: () => import(/* webpackChunkName: "kyc" */ '@/views/kyc_auth/cert_face'),
    meta: {
      title: '人脸核验'
    }
  },
  {
    path: '/kycAuth/result',
    name: 'kyc_result',
    component: () => import(/* webpackChunkName: "kyc" */ '@/views/kyc_auth/result'),
    meta: {
      title: '人脸认证结果'
    }
  },
  // 终端kyc
  {
    path: '/termKyc/index',
    name: 'term_kyc',
    component: () => import(/* webpackChunkName: "termKyc" */ '@/views/term_kyc/index'),
    meta: {
      title: '持卡人实名认证'
    }
  },
  {
    path: '/termKyc/cert_face',
    name: 'term_kyc_cert_face',
    component: () => import(/* webpackChunkName: "termKyc" */ '@/views/term_kyc/cert_face'),
    meta: {
      title: '人脸核验'
    }
  },
  {
    path: '/termKyc/result',
    name: 'term_kyc_result',
    component: () => import(/* webpackChunkName: "termKyc" */ '@/views/term_kyc/result'),
    meta: {
      title: '人脸认证结果'
    }
  },
  // 人脸识别公共页面 (目前合伙人平台有跳转过来)
  {
    path: '/commonFace',
    name: 'commonFace',
    component: () => import(/* webpackChunkName: "commonFace" */ '@/views/common_face'),
    meta: {
      title: '人脸核验'
    }
  },
  {
    path: '/404',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "error" */ '@/views/404'),
    meta: {
      title: '404'
    }
  },
  {
    path: '/500',
    name: 'serverError',
    component: () => import(/* webpackChunkName: "error" */ '@/views/500'),
    meta: {
      title: '500'
    }
  },
  {
    path: '/:pathMatch(.*)',
    redirect: () => {
      return { path: '/404' }
    }
  }
]
